import { Button, IconButton, Stack, Tooltip } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FixIcon from "src/assets/svg-icons/fix.svg";
import OrdersMatchingPopup from "../../orders-matching-popup";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";

const TableActions = ({ row, refetch }: { row: any; refetch: Function }) => {
  const { t: generalT } = useTranslation("general");
  const { t } = useTranslation("matching");
  const [open, setOpen] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsViewOnly(false);
  };

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      {row.is_matched ? (
        <>
          <Tooltip title={generalT("edit")}>
            <IconButton onClick={handleOpen}>
              <img src={EditIcon} alt="" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("view")}>
            <IconButton
              onClick={() => {
                setIsViewOnly(true);
                handleOpen();
              }}
            >
              <VisibilityOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <Button
          size="small"
          variant="contained"
          startIcon={<img src={FixIcon} alt="" />}
          sx={{ whiteSpace: "nowrap" }}
          onClick={handleOpen}
        >
          {t("fix")}
        </Button>
      )}

      {open && (
        <OrdersMatchingPopup
          open={open}
          handleClose={handleClose}
          row={row}
          refetch={refetch}
          isViewOnly={isViewOnly}
        />
      )}
    </Stack>
  );
};
export default TableActions;
